module.exports = __webpack_public_path__ + "img/Mb_MiddleSide_right.951771e7.jpg";